/* src/app/modules/shared/components/column/column-aroma/column-aroma.component.scss */
app-column-aroma {
  display: contents;
}
/*# sourceMappingURL=column-aroma.component.css.map */
